import { useEffect, useState, useContext } from 'react';
import {
    ContainerNull,
    Container,
    ContainerProdutos,
    Titulo,
    AreaHeader,
    AreaPesquisa,
    ButtonNovo,
    ContainerTabela,
    Tabela,
    Thead,
    TR,
    TH,
    Tbody,
    TD,
    ButtonEditar,
    ButtonDeletar,
    ModalDeletarCampanhas
} from './estilo';
import { toast } from 'react-toastify';
import { AuthContext } from '../../../contexts/auth';
import api from '../../../services/api';
import InputPesquisa from '../../InputPesquisa';
import {IoAlertCircleOutline, IoCloseOutline} from 'react-icons/io5';

export default function Campanhasdash(){
    const {user,signOut} = useContext(AuthContext);
    const [loading,setLoading] = useState(true);
    const [campanhas,setCampanhas] = useState([]);
    const [campanhasFiltradas, setCampanhasFiltradas] = useState([]);
    const [campanhasDeletar, setCampanhasDeletar] = useState([]);
    const [abrirModalDeletar, setAbrirModalDeletar] = useState(false);

    console.log(campanhasDeletar)

    const buscaCampanhas = () => {
        setLoading(true)
        api.get('/campanhas',
            {
                headers:{
                    'Authorization':user.token
                }
            }
        )
        .then((resp)=>{
            setCampanhas(resp.data.campanhas)
            setCampanhasFiltradas(resp.data.campanhas)
            setLoading(false)
        })
        .catch((error)=>{
            if(error.response.status === 401){
                toast.info(error.response.data.error)
                signOut()
            }else{
                toast.error(error.response.data.error)
                setLoading(false)
            }
        })
    };
    
    useEffect(() => {
        buscaCampanhas()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) 

    function checkCampanha(id){
        console.log(id)
        if(campanhasDeletar.includes(id)){
            setCampanhasDeletar(campanhasDeletar.filter(idCampanha => idCampanha !== id))
        }else{
            setCampanhasDeletar([...campanhasDeletar, id])
        }
    }

    function filtrar(lista, valor) {
        return lista.filter((campanha) => (
            campanha.nome.toUpperCase().includes(valor.toUpperCase()) ||
            String(campanha.id).toUpperCase().includes(valor)
        ));
    }

    function abrirDeletarCampanhas(){
        setAbrirModalDeletar(true)
    }

    function deletarCampanhas(){
        setLoading(true)
        api.delete('/campanhas/',
            {
                data:{
                    campanhasId:campanhasDeletar
                },
            headers:{
                'Authorization':user.token
            }
        }
        )
        .then((resp)=>{
            toast.success(resp.data.message)
            setLoading(false)
            setAbrirModalDeletar(false)
            setCampanhasDeletar([])
            buscaCampanhas()
        })
        .catch((error)=>{
            if(error.response.status === 401){
                toast.info(error.response.data.error)
                signOut()
            }else{
                toast.error(error.response.data.error)
                setLoading(false)
            }
        })
    }

    if (loading) return (
        <Container>
            <ContainerProdutos>
                <Titulo>Carregando...</Titulo>
            </ContainerProdutos>
        </Container>
    )

    return(
        <Container>
            <ContainerProdutos>
                <Titulo>LISTA DE CAMPANHAS</Titulo>
                <AreaHeader>
                    <div className='area-header-campanhas'>
                        <AreaPesquisa>
                            <InputPesquisa
                                lista={campanhas}
                                setLista={setCampanhasFiltradas}
                                funcaoDeFiltro={filtrar}
                                />
                        </AreaPesquisa>

                        <ButtonNovo to='campanhas/novo'>
                            Novo
                        </ButtonNovo>
                    </div>
                    <ButtonDeletar disabled={campanhasDeletar.length === 0} className={campanhasDeletar.length === 0 ? 'disabled' : ''} onClick={()=> abrirDeletarCampanhas()}>
                        Deletar
                    </ButtonDeletar>
                </AreaHeader>

                {campanhasFiltradas.length === 0 ? (
                    <ContainerNull>
                        <IoAlertCircleOutline size={50} color='#FF0000'/>
                        <h1>Nenhuma campanha encontrada...</h1>
                    </ContainerNull>
                ) : (
                    <ContainerTabela>
                        <Tabela>
                            <Thead>
                                <TR>
                                    <TH scope='col'>Id</TH>
                                    <TH scope='col'>Nome</TH>
                                    <TH scope='col'>Data de inicio</TH>
                                    <TH scope='col'>Data de fim</TH>
                                    <TH scope='col'>Selecionar</TH>
                                    <TH scope='col'>#</TH>
                                </TR>
                            </Thead>
                                <Tbody>
                                    {campanhasFiltradas.map((campanha)=> (
                                        <TR key={campanha.id}>
                                            <TD data-label='id'>{campanha.id}</TD>
                                            <TD data-label='campanha'>{campanha.nome}</TD>
                                            <TD data-label='data de inicio'>{campanha.dataInicio}</TD>
                                            <TD data-label='data de fim'>{campanha.dataFim}</TD>
                                            <TD data-label='deletar'>
                                                <input type='checkbox' checked={campanhasDeletar.includes(campanha.id)} onChange={()=> checkCampanha(campanha.id)} />
                                            </TD>
                                            <TD data-label='#'>
                                                <ButtonEditar to={`campanhas/editar/${campanha.id}`}>
                                                    EDITAR
                                                </ButtonEditar>
                                            </TD>
                                        </TR>
                                    ))}
                                </Tbody>
                        </Tabela>
                    </ContainerTabela>
                )}
                {abrirModalDeletar && (
                    <ModalDeletarCampanhas>
                        <div className='area-modal'>
                            <IoCloseOutline size={20} color='#FFFFFF' className='close' onClick={()=> setAbrirModalDeletar(false)} />
                            <h1>Deletar Campanhas</h1>
                            <p>Tem certeza que deseja deletar as campanhas selecionadas?</p>
                            <div className='area-buttons'>
                                <button className='aprovar' onClick={()=> deletarCampanhas()}>Deletar</button>
                            </div>
                        </div>
                    </ModalDeletarCampanhas>
                )}
            </ContainerProdutos>
        </Container>
    )
}